import React, {useEffect, useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {Formik} from 'formik';
import {useHistory} from 'react-router-dom';
import {useOrdersPageUIContext} from '../OrdersPageUIContext';
import moment from 'moment';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {FilterRangePicker} from '../../../_common/components/FieldDatepicker';
import ButtonAction from '../../../_common/components/ButtonAction';
import ClearIcon from '../../../_common/components/ClearIcon';
import FilterInputTypeahead from '../../../_common/components/FilterInputTypeahead';
import CustomerItem from '../../../_common/components/CustomerItem';
import FilterText from '../../../_common/components/FilterText';
import FilterSelect from '../../../_common/components/FilterSelect';
import * as actions from '../../../_common/actions/findCustomers';
import {generateExcelFile} from '../../../_common/utils/excel';
import {columnNamesOrders} from '../../../_common/constants/excelColumnNames';
import {getOrdersListForExcel} from '../../_redux/actions/OrdersPageFilterActions';
import {getUniqueElementsFromArray} from '../../../_common/utils/getUniqueElementsFromArray';
import {applyFilter} from '../../../../../utils/prepareApplyFilter';
import styles from '../../../_common/styles/filtersBar.module.scss';

export function OrdersPageFilters({statusList}) {
  const [inputCustomer, setInputCustomer] = useState('');
  const ordersContext = useOrdersPageUIContext();
  const ordersProps = useMemo(() => {
    return {
      queryParams: ordersContext.queryParams,
      setQueryParams: ordersContext.setQueryParams,
    };
  }, [ordersContext]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const intl = useIntl();
  const prefix = 'filter-placeholder';

  const qs = new URLSearchParams(window.location.search);
  let orderNumber = qs.get('orderNumber') || '';
  let shumaID = qs.get('shumaID') || '';
  let createdFromDate = qs.get('createdFromDate') || '';
  let createdToDate = qs.get('createdToDate') || '';
  let dueFromDate = qs.get('dueFromDate') || '';
  let dueToDate = qs.get('dueToDate') || '';
  let customerID = qs.get('customerID') || '';
  let status = qs.get('status') || '';

  const onChangeCreatedDate = (fromDate, toDate, setFieldValue, handleSubmit) => {
    setFieldValue('createdFromDate', fromDate || '');
    setFieldValue('createdToDate', toDate || '');
    handleSubmit();
  };
  const onChangeDueDate = (fromDate, toDate, setFieldValue, handleSubmit) => {
    setFieldValue('dueFromDate', fromDate);
    setFieldValue('dueToDate', toDate);
    handleSubmit();
  };
  const onChangeCustomer = (value) => (setFieldValue, handleSubmit) => {
    if (value && value[0]) {
      const {firstName, lastName, customerID} = value[0];
      const inputCustomerValue = `${firstName || ''} ${lastName || ''}`;
      setFieldValue('customerID', customerID);
      setFieldValue('inputCustomer', inputCustomerValue);
      setInputCustomer(inputCustomerValue);
      handleSubmit();
    }
  };

  const clearCreatedDate = (setFieldValue, handleSubmit) => {
    setFieldValue('createdFromDate', '');
    setFieldValue('createdToDate', '');
    handleSubmit();
  };
  const clearDueDate = (setFieldValue, handleSubmit) => {
    setFieldValue('dueFromDate', '');
    setFieldValue('dueToDate', '');
    handleSubmit();
  };
  const clearCustomer = (setFieldValue, handleSubmit) => {
    setFieldValue('customerID', '');
    setFieldValue('inputCustomer', '');
    setInputCustomer('');
    handleSubmit();
  };

  const exportOrdersFileFunc = () => {
    // Here s = start, r = row, c=col, e= end
    const merge = [{s: {r: 1, c: 7}, e: {r: 1, c: 12}},];
    const customCell = (ws) => {

      return ws['H2'] = {
        t: 's',
        v: 'פרטי איש קשר',
        s: {
          alignment: {
            horizontal: 'center'
          },
          font: {
            bold: true,
          }
        }
      };
    };
    setLoading(true);
    dispatch(getOrdersListForExcel(ordersProps.queryParams))
      .then(prepareDataForExcel)
      .then((data) => {
        generateExcelFile(
          data,
          'Orders.xlsx',
          'הזמנות',
          merge,
          customCell
        );
      })
      .catch((error) => {
        console.error(`Error: + ${error}`);
      }).finally(() => setLoading(false));
  };
  const prepareDataForExcel = data => {
    return data.map((item, index) => {
      const {
        orderNumber,
        createdDate,
        customers,
        shumaCount,
        dueDate,
        status,
        contactFirstName,
        contactLastName,
        contactPhone,
        contactJob,
        contactOrganization,
        contactEmail,
        contactAddress,
        lawyerName,
        paid,
        totalPayment
      } = item;

      return {
        [columnNamesOrders[0]]: index + 1,
        [columnNamesOrders[1]]: orderNumber,
        [columnNamesOrders[2]]: createdDate ? moment(createdDate).format('DD.MM.YYYY') : '',
        [columnNamesOrders[3]]: Boolean(customers) ? getUniqueElementsFromArray(customers).toString() : '',
        [columnNamesOrders[4]]: shumaCount,
        [columnNamesOrders[5]]: dueDate ? moment(dueDate).format('DD.MM.YYYY') : '',
        [columnNamesOrders[6]]: status
          ? statusList.filter(item => item.value === status)[0].label : '',
        [columnNamesOrders[7]]: [contactFirstName, contactLastName].filter(Boolean).join(' '),
        [columnNamesOrders[8]]: contactPhone,
        [columnNamesOrders[9]]: contactJob,
        [columnNamesOrders[10]]: contactOrganization,
        [columnNamesOrders[11]]: contactEmail,
        [columnNamesOrders[12]]: contactAddress,
        [columnNamesOrders[13]]: lawyerName,
        [columnNamesOrders[14]]: paid,
        [columnNamesOrders[15]]: totalPayment,
      };
    });
  };

  const handleCreateOrder = () => history.push(`/order-details/-1`);

  useEffect(() => {
    setInputCustomer(window.localStorage.getItem('inputCustomer'));
  }, []);

  useEffect(() => {
    const value = Boolean(inputCustomer) ? inputCustomer : '';
    window.localStorage.setItem('inputCustomer', value);
  }, [inputCustomer]);

  return (
    <Formik
      initialValues={{
        orderNumber,
        shumaID,
        createdFromDate,
        createdToDate,
        dueFromDate,
        dueToDate,
        inputCustomer: '',
        customerID,
        status
      }}
      onSubmit={(values) => applyFilter(values, ordersProps)}
      enableReinitialize={true}
    >
      {({values, handleBlur, handleSubmit, setFieldValue}) => (
        <form onSubmit={handleSubmit} className={styles.container}>
          <div className={styles.filtersContainer}>
            <FilterText
              fieldName={'orderNumber'}
              value={values.orderNumber}
              placeholder={intl.formatMessage({id: `${prefix}-order-number`, defaultMessage: 'Order number'})}
              containerClassnames={styles.filter}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <FilterText
              fieldName={'shumaID'}
              value={values.shumaID}
              placeholder={intl.formatMessage({id: `${prefix}-shumaID`, defaultMessage: 'Shuma ID'})}
              containerClassnames={styles.filter}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <div className={styles.filter}>
              <FilterRangePicker
                onChange={(fromDate, toDate) => onChangeCreatedDate(fromDate, toDate, setFieldValue, handleSubmit)}
                placeholder={[intl.formatMessage({id: `${prefix}-createDate`, defaultMessage: 'Create date'})]}
                startDate={createdFromDate}
                endDate={createdToDate}
                label={
                  createdFromDate || createdToDate
                    ? intl.formatMessage({id: `${prefix}-createDate`, defaultMessage: 'Create date'})
                    : null
                }
              />
              <ClearIcon onClick={() => clearCreatedDate(setFieldValue, handleSubmit)}/>
            </div>
            <div className={styles.filter}>
              <FilterRangePicker
                onChange={(fromDate, toDate) => onChangeDueDate(fromDate, toDate, setFieldValue, handleSubmit)}
                placeholder={[intl.formatMessage({id: `${prefix}-dueDate`, defaultMessage: 'Due date'})]}
                startDate={dueFromDate}
                endDate={dueToDate}
                label={
                  dueFromDate || dueToDate
                    ? intl.formatMessage({id: `${prefix}-dueDate`, defaultMessage: 'Due date'})
                    : null
                }
              />
              <ClearIcon onClick={() => clearDueDate(setFieldValue, handleSubmit)}/>
            </div>
            <FilterInputTypeahead
              fieldId={'inputCustomer'}
              value={values.inputCustomer}
              labelKey={option => `${option.firstName} ${option.lastName}`}
              placeholder={inputCustomer ? inputCustomer : intl.formatMessage({
                id: `${prefix}-customer`,
                defaultMessage: 'Customer'
              })}
              onChange={(value) => onChangeCustomer(value)(setFieldValue, handleSubmit)}
              setFieldValue={setFieldValue}
              renderMenuItemChildren={option => <CustomerItem {...option}/>}
              dispatch={dispatch}
              handleFindItem={(input) => dispatch(actions.findCustomer(input))}
              onClearValue={() => clearCustomer(setFieldValue, handleSubmit)}
              customContainerStyles={styles.filter}
            />
            <FilterSelect
              fieldName={'status'}
              valueName={values.status}
              options={statusList}
              placeholder={intl.formatMessage({id: `${prefix}-status`, defaultMessage: 'Status'})}
              containerClassnames={styles.filter}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
          </div>
          <div className={styles.buttonsContainer}>
            <ButtonAction
              label={intl.formatMessage({id: 'orders-page-button-create-order', defaultMessage: 'Create order'})}
              useIcon={'/media/common/Plus_white.svg'}
              onClick={handleCreateOrder}
            />
            <ButtonAction
              variant={'success'}
              label={
                <>
                  {loading
                    ? (
                      <div className="spinner-border spinner-border-md m-auto text-light" role="status"/>
                    )
                    : (
                      <>
                        <img
                          src={toAbsoluteUrl('/media/common/Excel_white.svg')}
                          alt="export" className={'mr-2'}
                        />
                        <span>{intl.formatMessage({id: 'button-export-to-excel', defaultMessage: 'Export'})}</span>
                      </>
                    )
                  }
                </>
              }
              onClick={exportOrdersFileFunc}
              customClassnames={'ml-4 w-100px'}
            />
          </div>
        </form>
      )}
    </Formik>
  );
}

export default OrdersPageFilters;
